import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const WaitlistPage = () => {
    const { signOut, user } = useAuth();
    const navigate = useNavigate();

    const handleSignOut = async () => {
        await signOut();
        navigate('/signin');
    };

    return (
        <div className="min-h-screen bg-base-200 flex items-center justify-center px-4">
            <div className="max-w-md w-full bg-base-100 rounded-xl shadow-2xl overflow-hidden">
                <div className="p-8 text-center">
                    <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </div>

                    <h1 className="text-3xl font-bold mb-2">You're on the waitlist!</h1>
                    <p className="text-base-content/60 mb-8">
                        Hi <span className="font-semibold">{user?.name}</span>, thank you for signing up.
                        We are currently in early access mode and approving users in batches.
                        You will receive an email once your account is active.
                    </p>

                    <div className="space-y-4">
                        <div className="alert alert-info shadow-sm text-sm">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="stroke-current shrink-0 w-6 h-6"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                            <span>Status: Pending Approval</span>
                        </div>

                        <button
                            onClick={handleSignOut}
                            className="btn btn-outline btn-block"
                        >
                            Sign Out
                        </button>
                    </div>
                </div>
                <div className="bg-base-200/50 p-4 text-center text-xs text-base-content/40">
                    StockAlgoTrader &copy; 2026
                </div>
            </div>
        </div>
    );
};

export default WaitlistPage;
